// extracted by mini-css-extract-plugin
export default {"wrapper":"css_wrapper__fovwA","header":"css_header__aKzOt","videoTitle":"css_videoTitle__rSXCh","headerInfo":"css_headerInfo__WGbzc","video":"css_video__GFn1f"};